<style src="./EditMaxPrice.scss" lang="scss" scoped></style>
<template>
  <section class="edit-max-price">
    <section class="item-description">
      <div class="top-row">
        <span class="lab">{{ editMaxPrice.item.lab }}</span>
        <span class="code-prod">{{ editMaxPrice.item.codProd }}</span>
      </div>

      <div class="item-name">
        <span class="comercial-name">{{ editMaxPrice.item.comercialName }}</span>
        <span class="pativo">{{ editMaxPrice.item.pativo }}</span>
      </div>

      <div class="item-costs">
        <div class="field code">
          <span class="title">RMS</span>
          <span class="value">{{ editMaxPrice.item.rmsCode }}</span>
        </div>

        <div class="field code">
          <span class="title">GGREM</span>
          <span class="value">{{ editMaxPrice.item.ggremCode }}</span>
        </div>

        <div class="field factor">
          <span class="title">FATOR</span>
          <span class="value">{{ editMaxPrice.item.factor }}</span>
        </div>

        <div class="field cost">
          <span class="title">CUSTO</span>
          <span class="value">{{ editMaxPrice.item.cost }}</span>
        </div>
      </div>
    </section>

    <section class="search-bar">
      <textbox
        v-model="filter.searchText"
        label="Buscar produto"
        placeholder="Digite o nome do produto"
        class="textbox"
        :autofocus="true"
        :debounce="300"
        @debounce="searchProduct"
        v-shortkey.focus="['ctrl', 'f']"
        ref="searchBox" />
    </section>

    <section class="search-result">
      <div class="many-result" v-if="showManyResultsIssue">
        <icon-danger class="result-icon icon-warning"/>
        <span>Foram encontrados {{ countResult }} resultados. Refine sua busca para um resultado mais preciso.</span>
      </div>

      <div class="empty-result" v-if="!showManyResultsIssue && filteredList.length === 0">
        <icon-empty class="result-icon icon-danger"/>
        <span>Sua busca não retornou nenhum resultado.</span>
      </div>
      <page-navigator
        v-show="paginator.totalPage > 0"
        :total-pages="paginator.totalPage"
        :per-page="paginator.perPage"
        v-model="paginator.actualPage" />
      <ul class="list-container">
        <li
          v-for="(item, itemIdx) in filteredList"
          :key="itemIdx"
          @click="setMaxPrice(item, itemIdx)"
          class="list-item"
          :class="{ 'waiting': item.waiting }">

          <div class="top-row">
            <span class="lab">{{ item.lab }}</span>
          </div>

          <div class="item-name">
            <span class="comercial-name">{{ item.comercialName }}</span>
            <span class="pativo">{{ item.pativo }}</span>
            <span class="presentation">{{ item.presentation }}</span>
          </div>

          <div class="item-costs-container">
            <div class="item-costs">
              <div class="field code">
                <span class="title">RMS</span>
                <span class="value">{{ item.rmsCode }}</span>
              </div>

              <div class="field code">
                <span class="title">GGREM</span>
                <span class="value">{{ item.ggremCode }}</span>
              </div>

              <div class="field factor">
                <span class="title">FATOR</span>
                <span class="value">{{ item.factor | DecimalNumber }}</span>
              </div>

              <div class="field cost">
                <span class="title">CUSTO</span>
                <span class="value">{{ item.computedValue | CurrencyBR }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
import { Textbox, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
import { IconDanger, IconEmpty } from '@/components/primitives/icons'
import { SearchCmed } from '@/brain/record/cmed'
import { SetCodesToProduct } from '@/brain/record/stock'
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'

export default {
  name: 'EditMaxPrice',
  components: {
    PageNavigator,
    Textbox,
    IconDanger,
    IconEmpty
  },
  extends: {
    ...SourcePaginatorMixin
  },
  props: {
    editMaxPrice: {
      default: {
        item: null,
        itemIndex: null
      }
    }
  },
  filters: { CurrencyBR, DecimalNumber },
  data () {
    return {
      filter: {
        searchText: ''
      },
      filteredList: [],
      countResult: '0',
      showManyResultsIssue: false
    }
  },
  watch: {
    paginator: {
      handler () {
        this.searchProduct()
      },
      deep: true
    }
  },
  methods: {
    searchProduct () {
      if (this.filter.searchText.length < 1) {
        this.filteredList = []
        this.paginator.totalRegister = 0
        this.paginator.totalPage = 0
        return false
      }
      const params = this.buildQuery({ filters: this.filter })

      SearchCmed({ params })
        .then((result) => {
          this.filteredList = result.list
          this.paginator.totalRegister = result.rows
          this.paginator.totalPage = Math.floor(result.rows / this.paginator.perPage)
        })
    },
    async setMaxPrice ({ ggremCode = null, eanCode = null, rmsCode = null }, itemIndex) {
      this.$set(this.filteredList[itemIndex], 'waiting', true)
      if (!ggremCode) {
        return false
      }

      const queryData = {
        codProd: this.editMaxPrice.item.codProd,
        ggremCode,
        eanCode,
        rmsCode
      }

      try {
        await SetCodesToProduct(queryData)
      } catch (err) {
        this.$toasted.error(err, 'O CMED não pode ser anexado!')
        this.filteredList[itemIndex].waiting = false
        return false
      }

      this.$toasted.success('O CMED foi anexado com sucesso!')
      this.filteredList[itemIndex].waiting = false
      this.$emit('confirmed-edit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cmed/components/right-panel/edit-max-price/EditMaxPrice.vue